import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import useModel from "../common/useModel";
import Contactsusmodel from "./Contactsusmodel";
import { ToastContainer, toast } from "react-toastify";

const leadDashboard = (props) => {
  const [contact, handleContact] = useState({});
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);

  const [statusArray, handleStatusArray] = useState([
    "Open",
    "Active",
    "Converted online",
    "Converted offline",
    "Duplicate",
    "Not reachable",
    "Unqualified",
    "Future Plan",
    "Audit in progress",
    "Audit Completed",
    "Not interested",
    "Closed",
  ]);
  const [daycount, handledaycount] = useState({});
  const [contactDetail, handleContactDetail] = useState([]);
  const { isShowing, toggle } = useModel();
  const [listview, handlelistView] = useState(true);
  const [dataview, handledataview] = useState(false);
  const [interactionView, handleinteractionView] = useState(false);
  const [selectedlead, handleselectedleads] = useState();
  const [selectedinteractions,handleselectedinteractions] = useState();
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  const [clusterdata, handleClusterData] = useState([]);
  const [clusterdatanametype, handleClusterDataNameType] = useState(undefined);
  const [datefilter, handledatefilter] = useState("");
  const cusrsorstyle = {
    cursor: "pointer",
  };
  useEffect(() => {
    getContactUs(0);
    
    if (adminData.role !== "auditAdmin" && adminData.role !== "admin") {
      handleStatusArray(
        statusArray.filter((e) => {
          return e !== "Audit Completed" && e !== 'Audit in progress' && e !== "Closed";
        })
      );
    }
   }, []);

  useEffect(() => {
    getClusterData(0);
  }, []);

  //Fetching contact list
  const getContactUs = async (skip, status) => {
    console.log("status status", status);
    var adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
    
    var paramsConstrct = {
      cluster: adminInfo.cluster,
      selectedCluster: clusterdatanametype,
      type: datefilter,
    };
    try {
      // 
      const data = await Axios.get(endPoints.getLeadStatus, {
        params: paramsConstrct,
      });
      handledaycount(data.data.data.count);
      if (data.data.data.data) {
        handleContact(data.data.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getClusterData = async (skip, name) => {
    try {
      const response = await Axios.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result.map((e) => {
        return e.name;
      }).sort();
      if (result) {
        handleClusterData(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  const callSearch = () => {
    getContactUs(0);
    handleinteractionView(false)
    handlelistView(true)
    handledataview(false)
  };

  const openPopup = (event, contactDetails) => {
    console.log(event.target.value);
    console.log(contactDetails.status);
    if (
      contactDetails &&
      contactDetails.status &&
      contactDetails.status != "New" &&
      event.target.value === "New"
    ) {
      console.log("Error");
      toast.warn("Status cannot be set to New", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: false,
        toastId: "1",
      });
    } else {
      contactDetails.status = event.target.value;
      contactDetails.showAddRemarks = true;
      contactDetails.showListRemarks = true;
      handleContactDetail(contactDetails);
      toggle();
    }
  };

  const openRemarksPopup = (contactDetails) => {
    console.log(contactDetails);
    contactDetails.showAddRemarks = false;
    contactDetails.showListRemarks = true;
    handleContactDetail(contactDetails);
    toggle();
  };

  const addNewRemarks = async (params) => {
    console.log(params);
    try {
      const data = await Axios.put(endPoints.addRemarksContactUs, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Remarks Added Successfully", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        });
        toggle();
        getContactUs(skip);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClusterData2 = async (e) => {
    handleClusterDataNameType(e.target.value);
  };

  const showdatadetails = (e) => {
    let currentdata =
      contact[e.target.parentElement.getAttribute("data-id")][
        e.target.getAttribute("data-id")
      ];
    if (currentdata.length > 0) {
      handledataview(true);
      handlelistView(false);
      handleselectedleads(currentdata.reverse());
    }
  };
  const getInteract = (e) => {
    let currentdata = selectedlead[e.target.getAttribute("data-id")];
    currentdata = currentdata.remarks.length > 0 ? currentdata.remarks.reverse(): currentdata.remarks
    if (currentdata.length > 0) {
      handledataview(false);
      handlelistView(false);
      handleinteractionView(true)
      handleselectedinteractions(currentdata);
    }
  };

  //Update Status for contact us entry
  const updateStatus = async (params) => {
    console.log(params);
    try {
      const data = await Axios.put(endPoints.updateContactUs, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        //   toast.success('Discount Added Sucessfully', {
        //     position:toast.POSITION.TOP_CENTER,
        //
        //     hideProgressBar:true,
        //     toastId:"1"
        //  });
        //  toggle();
        //  getContactUs(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Show table for contact list
  return (
    <div className="dashboardContainer">
      <Contactsusmodel
        isShowing={isShowing}
        hide={toggle}
        contactDetail={contactDetail}
        updateStatus={updateStatus}
        addNewRemarks={addNewRemarks}
      />{" "}
      <HeaderAdminpanel />
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>{" "}
        <section
          id="dashboard-rightContainer"
          className="dashboard-manageSales"
        >
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Contact Us |{" "}
              <span className="breadcrumb-active fct-breadcrumb">
                {" "}
                Lead Dashboard{" "}
              </span>{" "}
            </div>{" "}
          </div>
          <table cellPadding="10" cellSpacing="10" className="searchTable">
            <tbody>
              <tr>
                <td>
                  <div className="status-input search_camp search_list">
                    <select
                      className="packageType drop-down-icon status-dropdown"
                      onChange={handleClusterData2}
                    >
                      <option value="" disabled selected hidden>
                        {" "}
                        Choose ClusterName{" "}
                      </option>{" "}
                      {clusterdata.map((cluster) => (
                        <option> {cluster} </option>
                      ))}{" "}
                    </select>{" "}
                  </div>{" "}
                </td>
                <td>
                  <div className="status-input search_camp search_list">
                    <select
                      className="packageType drop-down-icon status-dropdown"
                      onChange={(e) => {
                        handledatefilter(e.target.value);
                      }}
                    >
                      <option value="createdby"> By Created date </option>
                      <option value="updatedby" selected>
                        {" "}
                        By last updated date{" "}
                      </option>
                    </select>{" "}
                  </div>{" "}
                </td>
                <td>
                  <span className="print_btn">
                    <button onClick={callSearch}> Search </button>{" "}
                  </span>{" "}
                  <span className="print_btn mrgLft10px">
                    <button onClick={clearSearch}> Clear </button>{" "}
                  </span>{" "}
                  {dataview && (
                    <span className="print_btn mrgLft10px">
                      <button
                        onClick={(e) => {
                          handlelistView(true);
                          handledataview(false);
                        }}
                      >
                        {" "}
                        Back to Lead View{" "}
                      </button>{" "}
                    </span>
                  )}
                  {interactionView && (
                    <span className="print_btn mrgLft10px">
                      <button
                        onClick={(e) => {
                          handlelistView(false);
                          handledataview(true);
                          handleinteractionView(false)
                        }}
                      >
                        {" "}
                        Back to Contacts View{" "}
                      </button>{" "}
                    </span>
                  )}
                </td>{" "}
              </tr>
            </tbody>{" "}
          </table>
          <div className="dashboard-content userListing-dashboard bg-white table-responsive">
            {listview && (
              <table
                className={
                  contact
                    ? "table table-striped master-table contact_list"
                    : "table table-striped master-table contact_list none"
                }
              >
                <thead>
                  <tr>
                    <th> Status </th> <th> Upto 7 days </th>{" "}
                    <th> 7 to 14 days </th> {/*<th>District</th>*/}{" "}
                    <th> 15 to 30 days </th>{" "}
                    <th className="contact_msg"> 1 to 2 months </th>{" "}
                    <th> 2 to 3 months </th> <th> 3 months beyond </th>{" "}
                    <th> Total </th>
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {Object.keys(contact).map((r, i) => (
                    <tr data-id={r}>
                      <td>{r === 'Follow Up'? 'Future Plan': r}</td>{" "}
                      <td
                        style={cusrsorstyle}
                        onClick={showdatadetails}
                        data-id="upto7"
                      >
                        {contact[r].upto7 ? contact[r].upto7.length : 0}
                      </td>{" "}
                      <td
                        style={cusrsorstyle}
                        onClick={showdatadetails}
                        data-id="upto15"
                      >
                        {contact[r].upto15 ? contact[r].upto15.length : 0}
                      </td>{" "}
                      <td
                        style={cusrsorstyle}
                        onClick={showdatadetails}
                        data-id="upto30"
                      >
                        {contact[r].upto30 ? contact[r].upto30.length : 0}
                      </td>{" "}
                      <td
                        style={cusrsorstyle}
                        onClick={showdatadetails}
                        data-id="upto2m"
                      >
                        {contact[r].upto2m ? contact[r].upto2m.length : 0}
                      </td>{" "}
                      <td
                        style={cusrsorstyle}
                        onClick={showdatadetails}
                        data-id="upto3m"
                      >
                        {contact[r].upto3m ? contact[r].upto3m.length : 0}
                      </td>{" "}
                      <td
                        style={cusrsorstyle}
                        onClick={showdatadetails}
                        data-id="beyond3"
                      >
                        {contact[r].beyond3 ? contact[r].beyond3.length : 0}
                      </td>{" "}
                      <td>
                        {(contact[r].upto7 ? contact[r].upto7.length : 0) +
                          (contact[r].upto15 ? contact[r].upto15.length : 0) +
                          (contact[r].upto30 ? contact[r].upto30.length : 0) +
                          (contact[r].upto2m ? contact[r].upto2m.length : 0) +
                          (contact[r].upto3m ? contact[r].upto3m.length : 0) +
                          (contact[r].beyond3 ? contact[r].beyond3.length : 0)}
                      </td>{" "}
                    </tr>
                  ))}
                  <tr>
                    <td>
                      <b>Total</b>
                    </td>
                    <td>{daycount.upto7}</td>
                    <td>{daycount.upto15}</td>
                    <td>{daycount.upto30}</td>
                    <td>{daycount.upto2m}</td>
                    <td>{daycount.upto3m}</td>
                    <td>{daycount.beyond3}</td>
                    <td>{daycount.total}</td>
                  </tr>
                </tbody>{" "}
              </table>
            )}
            {dataview && (
              <table
                className={
                  contact
                    ? "table table-striped master-table contact_list"
                    : "table table-striped master-table contact_list none"
                }
              >
                <thead>
                  <tr>
                    <th> Date </th> <th> Name </th> <th> State </th>{" "}
                    {/*<th>District</th>*/} <th> City </th>{" "}
                    <th className="contact_msg"> Message </th>{" "}
                    <th> Last Update </th> <th> Interactions </th>{" "}
                    <th> Company </th> <th>Email</th> <th>Mobile</th>
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {selectedlead.map((r, i) => (
                    <tr key={i}>
                      <td>
                        {moment(r.createdAt).format("DD/MM/YYYY HH:mm:A")}
                      </td>
                      <td>{r.name}</td>
                      <td>{r.state}</td>
                      <td>{r.city}</td>
                      <td>{r.message}</td>
                      <td>
                        {r.remarks.length > 0 &&
                          moment(r.remarks[0].date).format(
                            "DD/MM/YYYY hh:mm:A"
                          )}
                      </td>{" "}
                      <td style={cusrsorstyle}  data-id={i} onClick={getInteract}>
                        {" "}
                        {r.remarks ? r.remarks.length : "0"}{" "}
                      </td>{" "}
                      <td> {r.company} </td> <td> {r.email} </td>{" "}
                      <td> {r.mobile} </td>{" "}
                    </tr>
                  ))}
                </tbody>{" "}
              </table>
            )}
            {interactionView && (
              <table
                className={
                  contact
                    ? "table table-striped master-table contact_list"
                    : "table table-striped master-table contact_list none"
                }
              >
                <thead>
                  <tr>
                    <th> Date </th> <th> Status </th> <th> Remarks </th> <th> Added By</th>
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {selectedinteractions.map((r, i) => (
                    <tr key={i}>
                      <td>{moment(r.date).format("DD/MM/YYYY HH:mm:A")}</td>
                      <td>{r.status}</td>
                      <td>{r.remark}</td>
                      <td>{r.user_email}</td>
                    </tr>
                  ))}
                </tbody>{" "}
              </table>
            )}
            <div className="paginationTable">
              {" "}
              {(skip > 0 || count >= 10) && (
                <Pagination getAllData={getContactUs} totalRecords={count} />
              )}{" "}
            </div>{" "}
          </div>{" "}
          {contact.length === 0 ? <NoData /> : null}{" "}
        </section>{" "}
      </div>{" "}
      {/* {contact.length ===0 ?
                    <NoData /> : null} */}
      <ToastContainer />
    </div>
  );
};

export default connect(null, {})(leadDashboard);



// WEBPACK FOOTER //
// ./web/components/admin/contactUs/leaddashboard.js